import React, { useState } from "react";
import Sidebar from "../../Sidebar/Sidebar";
import Header from "../Header/Header";
import NewSightTest from "./Other Tabs/NewSightTest/NewSightTest/NewSightTest";
import "./Patient.css";

const Patient = () => {
  // these two states are for different tabs
  const [Tab, setTab] = useState("New Patient");
  const [Tab2, setTab2] = useState("Patient Information");
  const changeTab = (activeTab, nestedTab) => {
    setTab(activeTab);
    window.scroll(0, 0);
    if (activeTab === "New Sight Test") {
      setTab2(nestedTab);
    }
  };
  //   icons
  let arrowUpIcon = (
    <svg
      width="24"
      height="12"
      viewBox="0 0 24 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="mt-5 mr-2"
    >
      <path d="M0 12L12 0L24 12H0Z" fill="black" />
    </svg>
  );
  let eyeIcon = (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.62305 16.5C2.91555 9.46 9.08517 4.125 16.4992 4.125C23.9132 4.125 30.0814 9.46 31.3753 16.5C30.0828 23.54 23.9132 28.875 16.4992 28.875C9.08517 28.875 2.91692 23.54 1.62305 16.5H1.62305ZM16.4983 23.3759C20.2952 23.3759 23.3733 20.2978 23.3733 16.5009C23.3733 12.7039 20.2953 9.62587 16.4983 9.62585C12.7014 9.62584 9.62331 12.7039 9.62329 16.5008C9.62327 20.2978 12.7013 23.3758 16.4982 23.3759H16.4983ZM16.4993 20.625C15.0255 20.625 13.6638 19.8388 12.9269 18.5625C12.1901 17.2862 12.1901 15.7138 12.9269 14.4375C13.6638 13.1612 15.0255 12.375 16.4993 12.375C17.973 12.375 19.3348 13.1612 20.0716 14.4375C20.8085 15.7138 20.8085 17.2862 20.0716 18.5625C19.3348 19.8388 17.973 20.625 16.4993 20.625Z"
        fill="#4C004A"
      />
    </svg>
  );
  let attachementIcon = (
    <svg
      width="32"
      height="21"
      viewBox="0 0 32 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.397 7.94069C24.478 3.41263 20.5405 0 15.75 0C11.9439 0 8.66263 2.16549 7.02201 5.31569C3.08451 5.70951 0 9.05612 0 13.125C0 17.456 3.54368 21 7.875 21H24.9375C28.5469 21 31.5 18.0469 31.5 14.4375C31.5 10.9595 28.8096 8.13743 25.397 7.94069ZM17.85 11.8125V16.8H13.65V11.8125H9.1875L15.75 5.25L22.3125 11.8125H17.85Z"
        fill="#4C004A"
      />
    </svg>
  );
  let appointmentIcon = (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_762_7210)">
        <path
          d="M19.5295 25C18.0173 25 16.7287 24.467 15.6637 23.4009C14.5986 22.3348 14.0661 21.0449 14.0661 19.5312C14.0661 18.0176 14.5986 16.7277 15.6637 15.6616C16.7287 14.5955 18.0173 14.0625 19.5295 14.0625C21.0417 14.0625 22.3303 14.5955 23.3954 15.6616C24.4604 16.7277 24.9929 18.0176 24.9929 19.5312C24.9929 21.0449 24.4604 22.3348 23.3954 23.4009C22.3303 24.467 21.0417 25 19.5295 25ZM22.6515 18.75H20.31V16.4062C20.31 16.1947 20.2328 16.0116 20.0783 15.8569C19.9238 15.7023 19.7409 15.625 19.5295 15.625C19.3181 15.625 19.1352 15.7023 18.9807 15.8569C18.8263 16.0116 18.749 16.1947 18.749 16.4062V19.5312C18.749 19.7266 18.81 19.8934 18.932 20.0317C19.0539 20.1701 19.2043 20.2555 19.3832 20.2881C19.4157 20.3044 19.4645 20.3125 19.5295 20.3125H22.6515C22.8629 20.3125 23.0458 20.2352 23.2003 20.0806C23.3547 19.9259 23.432 19.7428 23.432 19.5312C23.432 19.3197 23.3547 19.1366 23.2003 18.9819C23.0458 18.8273 22.8629 18.75 22.6515 18.75ZM11.7247 20.3125H7.04172C6.83034 20.3125 6.64742 20.2352 6.49294 20.0806C6.33847 19.9259 6.26124 19.7428 6.26124 19.5312C6.26124 19.3197 6.33847 19.1366 6.49294 18.9819C6.64742 18.8273 6.83034 18.75 7.04172 18.75H11.7247C11.936 18.75 12.119 18.8273 12.2734 18.9819C12.4279 19.1366 12.5051 19.3197 12.5051 19.5312C12.5051 19.7428 12.4279 19.9259 12.2734 20.0806C12.119 20.2352 11.936 20.3125 11.7247 20.3125ZM7.04172 15.625H11.7247C11.936 15.625 12.119 15.7023 12.2734 15.8569C12.4279 16.0116 12.5051 16.1947 12.5051 16.4062C12.5051 16.6178 12.4279 16.8009 12.2734 16.9556C12.119 17.1102 11.936 17.1875 11.7247 17.1875H7.04172C6.83034 17.1875 6.64742 17.1102 6.49294 16.9556C6.33847 16.8009 6.26124 16.6178 6.26124 16.4062C6.26124 16.1947 6.33847 16.0116 6.49294 15.8569C6.64742 15.7023 6.83034 15.625 7.04172 15.625ZM14.8466 14.0625H7.04172C6.83034 14.0625 6.64742 13.9852 6.49294 13.8306C6.33847 13.6759 6.26124 13.4928 6.26124 13.2812C6.26124 13.0697 6.33847 12.8866 6.49294 12.7319C6.64742 12.5773 6.83034 12.5 7.04172 12.5H14.8466C15.058 12.5 15.2409 12.5773 15.3954 12.7319C15.5499 12.8866 15.6271 13.0697 15.6271 13.2812C15.6271 13.4928 15.5499 13.6759 15.3954 13.8306C15.2409 13.9852 15.058 14.0625 14.8466 14.0625ZM17.9686 10.9375H7.04172C6.83034 10.9375 6.64742 10.8602 6.49294 10.7056C6.33847 10.5509 6.26124 10.3678 6.26124 10.1562C6.26124 9.94466 6.33847 9.76156 6.49294 9.60693C6.64742 9.45231 6.83034 9.375 7.04172 9.375H17.9686C18.1799 9.375 18.3629 9.45231 18.5173 9.60693C18.6718 9.76156 18.749 9.94466 18.749 10.1562C18.749 10.3678 18.6718 10.5509 18.5173 10.7056C18.3629 10.8602 18.1799 10.9375 17.9686 10.9375ZM17.9686 4.6875H7.04172C6.83034 4.6875 6.64742 4.61019 6.49294 4.45557C6.33847 4.30094 6.26124 4.11784 6.26124 3.90625C6.26124 3.69466 6.33847 3.51156 6.49294 3.35693C6.64742 3.20231 6.83034 3.125 7.04172 3.125H17.9686C18.1799 3.125 18.3629 3.20231 18.5173 3.35693C18.6718 3.51156 18.749 3.69466 18.749 3.90625C18.749 4.11784 18.6718 4.30094 18.5173 4.45557C18.3629 4.61019 18.1799 4.6875 17.9686 4.6875ZM17.9686 7.8125H7.04172C6.83034 7.8125 6.64742 7.73519 6.49294 7.58057C6.33847 7.42594 6.26124 7.24284 6.26124 7.03125C6.26124 6.81966 6.33847 6.63656 6.49294 6.48193C6.64742 6.32731 6.83034 6.25 7.04172 6.25H17.9686C18.1799 6.25 18.3629 6.32731 18.5173 6.48193C18.6718 6.63656 18.749 6.81966 18.749 7.03125C18.749 7.24284 18.6718 7.42594 18.5173 7.58057C18.3629 7.73519 18.1799 7.8125 17.9686 7.8125ZM20.31 2.34375C20.31 2.13216 20.2328 1.94906 20.0783 1.79443C19.9238 1.63981 19.7409 1.5625 19.5295 1.5625H3.91977C3.70839 1.5625 3.52546 1.63981 3.37099 1.79443C3.21652 1.94906 3.13929 2.13216 3.13929 2.34375V3.125C3.57831 3.125 3.94823 3.27555 4.24904 3.57666C4.54985 3.87777 4.70026 4.24805 4.70026 4.6875C4.70026 5.12695 4.54985 5.49723 4.24904 5.79834C3.94823 6.09945 3.57831 6.25 3.13929 6.25V7.8125C3.57831 7.8125 3.94823 7.96305 4.24904 8.26416C4.54985 8.56527 4.70026 8.93555 4.70026 9.375C4.70026 9.81445 4.54985 10.1847 4.24904 10.4858C3.94823 10.7869 3.57831 10.9375 3.13929 10.9375V12.5C3.57831 12.5 3.94823 12.6506 4.24904 12.9517C4.54985 13.2528 4.70026 13.619 4.70026 14.0503C4.70026 14.4816 4.54985 14.8519 4.24904 15.1611C3.94823 15.4704 3.57831 15.625 3.13929 15.625V17.1875C3.57831 17.1875 3.94823 17.3381 4.24904 17.6392C4.54985 17.9403 4.70026 18.3065 4.70026 18.7378C4.70026 19.1691 4.54985 19.5394 4.24904 19.8486C3.94823 20.1579 3.57831 20.3125 3.13929 20.3125V21.0938C3.13929 21.3053 3.21652 21.4884 3.37099 21.6431C3.52546 21.7977 3.70839 21.875 3.91977 21.875H14.0661V23.4375H3.13929C2.71652 23.4375 2.35067 23.2829 2.04172 22.9736C1.73278 22.6644 1.57831 22.2982 1.57831 21.875V20.3125C1.15555 20.3125 0.789692 20.1579 0.480749 19.8486C0.171806 19.5394 0.017334 19.1691 0.017334 18.7378C0.017334 18.3065 0.171806 17.9403 0.480749 17.6392C0.789692 17.3381 1.15555 17.1875 1.57831 17.1875V15.625C1.15555 15.625 0.789692 15.4704 0.480749 15.1611C0.171806 14.8519 0.017334 14.4816 0.017334 14.0503C0.017334 13.619 0.171806 13.2528 0.480749 12.9517C0.789692 12.6506 1.15555 12.5 1.57831 12.5V10.9375C1.15555 10.9375 0.789692 10.7869 0.480749 10.4858C0.171806 10.1847 0.017334 9.81445 0.017334 9.375C0.017334 8.93555 0.171806 8.56527 0.480749 8.26416C0.789692 7.96305 1.15555 7.8125 1.57831 7.8125V6.25C1.15555 6.25 0.789692 6.09945 0.480749 5.79834C0.171806 5.49723 0.017334 5.12695 0.017334 4.6875C0.017334 4.24805 0.171806 3.87777 0.480749 3.57666C0.789692 3.27555 1.15555 3.125 1.57831 3.125V1.5625C1.57831 1.12305 1.73278 0.752767 2.04172 0.45166C2.35067 0.150553 2.71652 0 3.13929 0H20.31C20.7328 0 21.0986 0.150553 21.4076 0.45166C21.7165 0.752767 21.871 1.12305 21.871 1.5625V12.5H20.31V2.34375Z"
          fill="#4C004A"
        />
      </g>
      <defs>
        <clipPath id="clip0_762_7210">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
  let editIcon = (
    <svg
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.8279 0.385423C22.314 -0.128474 21.4953 -0.128474 20.9815 0.385423L11.0611 10.3057C10.9044 10.4538 10.7998 10.6454 10.7302 10.8544L9.11017 16.2631C8.97079 16.7248 9.10145 17.2212 9.44114 17.5609C9.68498 17.8135 10.0247 17.9441 10.3644 17.9441C10.4863 17.9441 10.6169 17.9267 10.7389 17.8918L16.1475 16.2719C16.3566 16.2022 16.5482 16.0977 16.6963 15.9409L26.6166 6.02056C26.8605 5.77671 26.9998 5.44575 26.9998 5.09734C26.9998 4.74899 26.8605 4.41801 26.6166 4.17412L22.8279 0.385423Z"
        fill="#3A57E8"
      />
      <path
        d="M25.6935 12.196C24.9719 12.196 24.3871 12.7812 24.3871 13.5024V22.2121C24.3871 23.4131 23.4102 24.3895 22.2097 24.3895H4.79032C3.58976 24.3895 2.6129 23.4131 2.6129 22.2121V4.79276C2.6129 3.59178 3.58976 2.61534 4.79032 2.61534H13.5C14.2217 2.61534 14.8065 2.03016 14.8065 1.30889C14.8065 0.587627 14.2217 0.00244141 13.5 0.00244141H4.79032C2.14893 0.00244141 0 2.15179 0 4.79276V22.2121C0 24.8531 2.14893 27.0024 4.79032 27.0024H22.2097C24.8511 27.0024 27 24.8531 27 22.2121V13.5024C27 12.7812 26.4152 12.196 25.6935 12.196Z"
        fill="#3A57E8"
      />
    </svg>
  );
  let deleteIcon = (
    <svg
      width="31"
      height="33"
      viewBox="0 0 31 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M25.3726 13.0401C25.3726 13.1335 24.6842 22.3975 24.291 26.2964C24.0448 28.689 22.5951 30.1402 20.4206 30.1815C18.7498 30.2213 17.1143 30.2351 15.505 30.2351C13.7966 30.2351 12.1258 30.2213 10.5041 30.1815C8.40242 30.1279 6.95149 28.6478 6.71783 26.2964C6.31333 22.3838 5.63749 13.1335 5.62493 13.0401C5.61237 12.7584 5.69779 12.4904 5.87115 12.2732C6.04199 12.0726 6.28821 11.9517 6.54699 11.9517H24.4631C24.7206 11.9517 24.9543 12.0726 25.1389 12.2732C25.3111 12.4904 25.3977 12.7584 25.3726 13.0401Z"
        fill="#C03221"
      />
      <path
        d="M27.125 8.21404C27.125 7.64921 26.7067 7.20669 26.2042 7.20669H22.4381C21.6718 7.20669 21.006 6.62675 20.8351 5.80905L20.6241 4.8072C20.3289 3.59646 19.3101 2.74854 18.1669 2.74854H12.8343C11.6786 2.74854 10.6699 3.59646 10.3633 4.87317L10.1661 5.81043C9.99402 6.62675 9.32822 7.20669 8.56319 7.20669H4.79706C4.29332 7.20669 3.875 7.64921 3.875 8.21404V8.73626C3.875 9.28735 4.29332 9.74361 4.79706 9.74361H26.2042C26.7067 9.74361 27.125 9.28735 27.125 8.73626V8.21404Z"
        fill="#C03221"
      />
    </svg>
  );

  return (
    <>
      <div className="grid grid-cols-12">
        <div className="grid col-span-2">
          <Sidebar acitveRoute={"patient"} />
        </div>
        {/*write component */}
        <div className="col-span-10">
          <Header />
          <br />
          <div className="p-4 pl-11">
            {/* Headings for different tabs */}
            {Tab === "New Patient" && (
              <h1 className="text-2xl font-bold">New Patient</h1>
            )}
            {Tab === "New Sight Test" && (
              <h1 className="text-2xl font-bold">New Sight Test</h1>
            )}
            {Tab === "Existing Patient Record" && (
              <div className="flex justify-between flex-wrap">
                <h1 className="text-2xl font-bold">Existing Patient Record</h1>
                <div className="flex justify-evenly">
                  <div>
                    <p className="font-bold">Patient ID :</p>
                    <input
                      type={"text"}
                      placeholder="112234"
                      className="bg-white shadow-md p-1 px-3"
                    />
                  </div>
                  <div className="mr-8 ml-8">
                    <p className="font-bold">Patient Name :</p>
                    <input
                      type={"text"}
                      placeholder="John Smith"
                      className="bg-white shadow-md p-1 px-3"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
          {Tab !== "New Sight Test" && (
            <div className="bg-blue-200 w-[1275px] m-auto flex justify-between rounded-md">
              {/* tab 1 */}
              <div
                onClick={() => changeTab("New Patient")}
                style={{
                  clipPath:
                    "polygon(0% 15%, 0 0, 16% 0, 94% 0, 94% 44%, 100% 52%, 94% 60%, 94% 100%, 17% 100%, 0 100%, 0 100%)",
                }}
                className={`${
                  Tab === "New Patient"
                    ? "bg-[#672c65] text-white"
                    : "bg-transparent"
                } p-4 rounded-bl-md rounded-tl-md px-16 cursor-pointer`}
              >
                <p className="text-xl">New Patient</p>
              </div>
              {/* tab 2 */}
              <div
                onClick={() => changeTab("Existing Patient Record")}
                style={{
                  clipPath:
                    "polygon(0% 15%, 0 0, 15% 0%, 96% 0, 96% 48%, 100% 55%, 96% 62%, 96% 100%, 15% 100%, 0 100%, 0% 85%)",
                }}
                className={`${
                  Tab === "Existing Patient Record"
                    ? "bg-[#4C004A] text-white"
                    : "bg-transparent"
                } p-4 px-10 cursor-pointer`}
              >
                <p className="text-xl">Existing Patient Record</p>
              </div>
              {/* arrowUp icon */}
              <div>{arrowUpIcon}</div>
            </div>
          )}
          {/* when tab is equal to New Sight Test and its other nested tabs Title  */}
          {Tab === "New Sight Test" && (
            <div className="bg-blue-200 w-[1275px] m-auto flex justify-between rounded-md">
              {/* tab 1 */}
              <div
                onClick={() =>
                  changeTab("New Sight Test", "Patient Information")
                }
                style={{
                  clipPath:
                    "polygon(0% 15%, 0 0, 16% 0, 94% 0, 94% 44%, 100% 52%, 94% 60%, 94% 100%, 17% 100%, 0 100%, 0 100%)",
                }}
                className={`${
                  Tab === "New Sight Test" && Tab2 === "Patient Information"
                    ? "bg-[#672c65] text-white"
                    : "bg-transparent"
                } p-4 rounded-bl-md rounded-tl-md cursor-pointer`}
              >
                <p className="text-xl">Patient Information</p>
              </div>
              {/* vertical line */}
              <div className="border-l-2 border-gray-500 h-8 self-center"></div>
              {/* tab 2 */}
              <div
                onClick={() => changeTab("New Sight Test", "Previous RX")}
                style={{
                  clipPath:
                    "polygon(0% 15%, 0 0, 15% 0%, 96% 0, 96% 48%, 100% 55%, 96% 62%, 96% 100%, 15% 100%, 0 100%, 0% 85%)",
                }}
                className={`${
                  Tab === "New Sight Test" && Tab2 === "Previous RX"
                    ? "bg-[#4C004A] text-white"
                    : "bg-transparent"
                } p-4 cursor-pointer`}
              >
                <p className="text-xl">Previous RX</p>
              </div>
              {/* vertical line */}
              <div className="border-l-2 border-gray-500 h-8 self-center"></div>
              {/* tab 3 */}
              <div
                onClick={() =>
                  changeTab("New Sight Test", "History & Symptoms")
                }
                style={{
                  clipPath:
                    "polygon(0% 15%, 0 0, 15% 0%, 96% 0, 96% 48%, 100% 55%, 96% 62%, 96% 100%, 15% 100%, 0 100%, 0% 85%)",
                }}
                className={`${
                  Tab === "New Sight Test" && Tab2 === "History & Symptoms"
                    ? "bg-[#4C004A] text-white"
                    : "bg-transparent"
                } p-4 cursor-pointer`}
              >
                <p className="text-xl">History & Symptoms</p>
              </div>
              {/* vertical line */}
              <div className="border-l-2 border-gray-500 h-8 self-center"></div>
              {/* tab 4 */}
              <div
                onClick={() =>
                  changeTab("New Sight Test", "Ocular Examination")
                }
                style={{
                  clipPath:
                    "polygon(0% 15%, 0 0, 15% 0%, 96% 0, 96% 48%, 100% 55%, 96% 62%, 96% 100%, 15% 100%, 0 100%, 0% 85%)",
                }}
                className={`${
                  Tab === "New Sight Test" && Tab2 === "Ocular Examination"
                    ? "bg-[#4C004A] text-white"
                    : "bg-transparent"
                } p-4 cursor-pointer`}
              >
                <p className="text-xl">Ocular Examination</p>
              </div>
              {/* vertical line */}
              <div className="border-l-2 border-gray-500 h-8 self-center"></div>
              {/* tab 5 */}
              <div
                onClick={() =>
                  changeTab("New Sight Test", "Additional Examination")
                }
                style={{
                  clipPath:
                    "polygon(0% 15%, 0 0, 15% 0%, 96% 0, 96% 48%, 100% 55%, 96% 62%, 96% 100%, 15% 100%, 0 100%, 0% 85%)",
                }}
                className={`${
                  Tab === "New Sight Test" && Tab2 === "Additional Examination"
                    ? "bg-[#4C004A] text-white"
                    : "bg-transparent"
                } p-4 cursor-pointer`}
              >
                <p className="text-xl">Additional Examination</p>
              </div>
              {/* vertical line */}
              <div className="border-l-2 border-gray-500 h-8 self-center"></div>
              {/* tab 6 */}
              <div
                onClick={() => changeTab("New Sight Test", "Refraction")}
                style={{
                  clipPath:
                    "polygon(0% 15%, 0 0, 15% 0%, 96% 0, 96% 48%, 100% 55%, 96% 62%, 96% 100%, 15% 100%, 0 100%, 0% 85%)",
                }}
                className={`${
                  Tab === "New Sight Test" && Tab2 === "Refraction"
                    ? "bg-[#4C004A] text-white"
                    : "bg-transparent"
                } p-4 cursor-pointer`}
              >
                <p className="text-xl">Refraction</p>
              </div>
              {/* arrowUp icon */}
              <div>{arrowUpIcon}</div>
            </div>
          )}
          {/* This code executed tab new patient is active */}
          {Tab === "New Patient" && (
            <>
              <>
                <div className="w-[1275px] bg-white p-4 m-auto">
                  <p className="text-2xl font-bold">Create New Patient</p>
                  <br />
                  <div className="grid grid-cols-3 gap-5">
                    {/* row1 */}
                    <div>
                      <p>Title</p>
                      <select className="w-full bg-gray-100 p-3 rounded-md">
                        <option value="select">Select</option>
                      </select>
                    </div>

                    <div>
                      <p>Forename</p>
                      <input
                        type="text"
                        placeholder="Joe"
                        className="w-full bg-gray-100 p-3 rounded-md"
                      />
                    </div>

                    <div>
                      <p>Surname</p>
                      <input
                        type="text"
                        placeholder="Deo"
                        className="w-full bg-gray-100 p-3 rounded-md"
                      />
                    </div>
                    {/* row 2 */}
                    <div>
                      <p>DoB</p>
                      <input
                        type="date"
                        className="w-full bg-gray-100 p-3 rounded-md"
                      />
                    </div>
                    <div>
                      <p>Address 1</p>
                      <input
                        type="text"
                        placeholder="Type here"
                        className="w-full bg-gray-100 p-3 rounded-md"
                      />
                    </div>
                    <div>
                      <p>Address 2</p>
                      <input
                        type="text"
                        placeholder="Type here"
                        className="w-full bg-gray-100 p-3 rounded-md"
                      />
                    </div>
                    {/* row 3 */}
                    <div>
                      <p>Town City</p>
                      <input
                        type="text"
                        placeholder="Type here"
                        className="w-full bg-gray-100 p-3 rounded-md"
                      />
                    </div>
                    <div>
                      <p>Country</p>
                      <input
                        type="text"
                        placeholder="Lorem ipsm"
                        className="w-full bg-gray-100 p-3 rounded-md"
                      />
                    </div>
                    <div>
                      <p>Passcode</p>
                      <input
                        type="text"
                        placeholder="Type here"
                        className="w-full bg-gray-100 p-3 rounded-md"
                      />
                    </div>
                    {/* row 4 */}
                    <div>
                      <p>Email</p>
                      <input
                        type="text"
                        placeholder="email@gmail.com"
                        className="w-full bg-gray-100 p-3 rounded-md"
                      />
                    </div>
                    <div>
                      <p>LandLine</p>
                      <input
                        type="text"
                        placeholder="12345"
                        className="w-full bg-gray-100 p-3 rounded-md"
                      />
                    </div>
                    <div>
                      <p>Mobile</p>
                      <input
                        type="text"
                        placeholder="+9298734900"
                        className="w-full bg-gray-100 p-3 rounded-md"
                      />
                    </div>
                    {/* row 5 */}
                    <div>
                      <p>Gender</p>
                      <select className="w-full bg-gray-100 p-3 rounded-md">
                        <option value="select">Select</option>
                        <option value="select">Male</option>
                        <option value="select">Female</option>
                        <option value="select">Other</option>
                      </select>
                    </div>
                    <div>
                      <p>Doctor</p>
                      <input
                        type="text"
                        placeholder="+9298734900"
                        className="w-full bg-gray-100 p-3 rounded-md"
                      />
                    </div>
                    <div>
                      <p>Patient Type</p>
                      <select className="w-full bg-gray-100 p-3 rounded-md">
                        <option value="select">Select</option>
                        <option value="select">Male</option>
                        <option value="select">Female</option>
                        <option value="select">Other</option>
                      </select>
                    </div>
                    {/* Row 6 */}
                    <div>
                      <p>HC2/HC3 Number</p>
                      <input
                        type="text"
                        placeholder="+9298734900"
                        className="w-full bg-gray-100 p-3 rounded-md"
                      />
                    </div>
                    <div>
                      <p>HC3 Patient Contribution</p>
                      <input
                        type="text"
                        placeholder="+9298734900"
                        className="w-full bg-gray-100 p-3 rounded-md"
                      />
                    </div>
                    <div className="flex justify-evenly pt-10">
                      <div>
                        <input
                          id="default-checkbox"
                          type="checkbox"
                          value=""
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        />
                        <label
                          htmlFor="default-checkbox"
                          className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >
                          Patient has Glucoma
                        </label>
                      </div>
                      <div>
                        <input
                          id="default-checkbox"
                          type="checkbox"
                          value=""
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        />
                        <label
                          htmlFor="default-checkbox"
                          className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >
                          Diabetic
                        </label>
                      </div>
                    </div>
                  </div>
                  <p className="my-4">Happy to contacted by:</p>
                  <input
                    id="default-checkbox"
                    type="checkbox"
                    value=""
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label
                    htmlFor="default-checkbox"
                    className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    SMS
                  </label>
                  &nbsp;&nbsp;
                  <input
                    id="default-checkbox"
                    type="checkbox"
                    value=""
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label
                    htmlFor="default-checkbox"
                    className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Phone
                  </label>{" "}
                  &nbsp;&nbsp;
                  <input
                    id="default-checkbox"
                    type="checkbox"
                    value=""
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label
                    htmlFor="default-checkbox"
                    className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Email
                  </label>
                  &nbsp;&nbsp;
                  <input
                    id="default-checkbox"
                    type="checkbox"
                    value=""
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label
                    htmlFor="default-checkbox"
                    className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Post
                  </label>
                  {/* Radio buttons */}
                  <p className="my-4">
                    Are you happy to recieve promotional communications?
                  </p>
                  <input
                    id="radio-button"
                    type="radio"
                    value=""
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label
                    htmlFor="radio-button"
                    className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Post
                  </label>
                  &nbsp;&nbsp; &nbsp;&nbsp;
                  <input
                    id="radio-2"
                    type="radio"
                    value=""
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label
                    htmlFor="radio-2"
                    className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Post
                  </label>
                  <div className="py-10">
                    <label
                      for="message"
                      class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Notes:
                    </label>
                    <textarea
                      id="message"
                      rows="4"
                      className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Write your thoughts here..."
                    ></textarea>
                    <button className="my-5 bg-[#4C004A] hover:bg-[#544354] text-white py-2 px-10 rounded-md float-right">
                      Save
                    </button>
                    &nbsp;
                  </div>
                </div>
                <br />
              </>
              <div className="p-10 bg-white w-[1275px] m-auto">
                <div className="grid grid-cols-3 gap-5">
                  <button
                    onClick={() =>
                      changeTab("New Sight Test", "Patient Information")
                    }
                    type="button"
                    className="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2 w-full"
                  >
                    {eyeIcon} &nbsp;&nbsp; New Sight Test
                  </button>

                  <button
                    type="button"
                    className="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2 w-full"
                  >
                    {eyeIcon} &nbsp;&nbsp; New CL/L Test
                  </button>

                  <button
                    type="button"
                    className="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2 w-full"
                  >
                    {eyeIcon} &nbsp;&nbsp; New Dispense
                  </button>

                  {/* row 2 */}
                  <button
                    type="button"
                    className="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2 w-full"
                  >
                    {attachementIcon} &nbsp;&nbsp; New Attachement
                  </button>
                  <button
                    type="button"
                    className="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2 w-full"
                  >
                    {eyeIcon} &nbsp;&nbsp; C/L Aftercare
                  </button>
                  <button
                    type="button"
                    className="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2 w-full"
                  >
                    {eyeIcon} &nbsp;&nbsp; Pre-screening
                  </button>
                  {/* row 3 */}
                  <div></div>
                  <button
                    type="button"
                    className="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2 w-full"
                  >
                    {appointmentIcon} &nbsp;&nbsp; Make Appointment
                  </button>
                  <div></div>
                </div>
              </div>
            </>
          )}
          {Tab === "Existing Patient Record" && (
            <>
              <div className="w-[1275px] p-4 m-auto">
                <div className="flex justify-between">
                  <p className="text-xl font-bold">Sight Test History</p>
                  <div className="flex justify-between w-[30%]">
                    <p className="text-xl font-bold">Date:</p>&nbsp;&nbsp;
                    <input type="date" className="bg-white p-2 w-full" />
                  </div>
                </div>
              </div>
              <br />
              <div className="w-[1275px] p-4 m-auto overflow-x-auto">
                <table className="rounded-md w-full">
                  <tr className="bg-blue-100">
                    <th>Record ID</th>
                    <th>Test Date</th>
                    <th>Payment</th>
                    <th>Final RX</th>
                    <th>Action</th>
                  </tr>

                  <tbody className="bg-white">
                    <tr className="text-center">
                      <td>1234</td>
                      <td>12/30/2023</td>
                      <td>64$</td>
                      <td>
                        <table>
                          <thead>
                            <tr>
                              <th></th>
                              <th className="font-light">SPH</th>
                              <th className="font-light">CYL</th>
                              <th className="font-light">Axis</th>
                              <th className="font-light">Prism</th>
                              <th className="font-light">Direction</th>
                              <th className="font-light">VA</th>
                              <th className="font-light">Near Add</th>
                              <th className="font-light">Prism</th>
                              <th className="font-light">Direction</th>
                              <th className="font-light">Near VA</th>
                              <th className="font-light">Int Add</th>
                              <th className="font-light">Prism</th>
                              <th className="font-light">Direction</th>
                              <th className="font-light">INTVA</th>
                            </tr>
                          </thead>
                          <tbody className="bg-white">
                            <tr>
                              <td>R:</td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>LE:</td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td className="flex">
                                <p>Pd</p> &nbsp; <p>Right:</p>
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td></td>
                              <td className="flex">
                                <p>Pd</p> &nbsp; <p>Left:</p>
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td></td>

                              <td className="flex">
                                <p>Pd</p> &nbsp; <p>Combined:</p>
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td></td>

                              <td>BVD:</td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td></td>
                              <td></td>

                              <td className="flex">
                                <p>BIN</p>&nbsp; <p>BCVA:</p>
                              </td>
                              <td>
                                <input
                                  className="border border-gray-300 rounded-md w-10"
                                  type="text"
                                />
                              </td>
                              <td></td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td className="flex mt-24">
                        {editIcon} &nbsp;&nbsp;&nbsp;
                        {deleteIcon}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />

              {/* headings for second table */}
              <div className="flex justify-between p-4 m-auto w-[1275px]">
                <p className="text-xl font-bold">Contact Lens History</p>
                <div className="flex justify-between w-[30%]">
                  <p className="text-xl font-bold">Date:</p>&nbsp;&nbsp;
                  <input type="date" className="bg-white p-2 w-full" />
                </div>
              </div>
              {/* second table */}
              <div className="w-[1275px] p-4 m-auto overflow-x-auto">
                <table className="rounded-md w-full">
                  <tr className="bg-blue-100">
                    <th>Record ID</th>
                    <th>Test Date</th>
                    <th>Payment</th>
                    <th>Final RX</th>
                    <th>Lens Type</th>
                    <th>Action</th>
                  </tr>
                  <tbody className="bg-white">
                    <tr className="text-center">
                      <td>1234</td>
                      <td>12/30/2023</td>
                      <td>64$</td>
                      <td>
                        <table>
                          <thead>
                            <tr>
                              <th></th>
                              <th className="font-light">SPH</th>
                              <th className="font-light">CYL</th>
                              <th className="font-light">Axis</th>
                              <th className="font-light">Add</th>
                              <th className="font-light">BC</th>
                              <th className="font-light">Diameter</th>
                            </tr>
                          </thead>
                          <tr>
                            <td>RE:</td>
                            <td>
                              <input
                                className="border border-gray-300 rounded-md w-10"
                                type="text"
                              />
                            </td>
                            <td>
                              <input
                                className="border border-gray-300 rounded-md w-10"
                                type="text"
                              />
                            </td>
                            <td>
                              <input
                                className="border border-gray-300 rounded-md w-10"
                                type="text"
                              />
                            </td>
                            <td>
                              <input
                                className="border border-gray-300 rounded-md w-10"
                                type="text"
                              />
                            </td>
                            <td>
                              <input
                                className="border border-gray-300 rounded-md w-10"
                                type="text"
                              />
                            </td>
                            <td>
                              <input
                                className="border border-gray-300 rounded-md w-10"
                                type="text"
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>LE:</td>

                            <td>
                              <input
                                className="border border-gray-300 rounded-md w-10"
                                type="text"
                              />
                            </td>
                            <td>
                              <input
                                className="border border-gray-300 rounded-md w-10"
                                type="text"
                              />
                            </td>
                            <td>
                              <input
                                className="border border-gray-300 rounded-md w-10"
                                type="text"
                              />
                            </td>
                            <td>
                              <input
                                className="border border-gray-300 rounded-md w-10"
                                type="text"
                              />
                            </td>
                            <td>
                              <input
                                className="border border-gray-300 rounded-md w-10"
                                type="text"
                              />
                            </td>
                            <td>
                              <input
                                className="border border-gray-300 rounded-md w-10"
                                type="text"
                              />
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td>
                        {" "}
                        <table className="text-center">
                          <thead>
                            <tr className="text-center">
                              <th>Lens Name Type:</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                RE: &nbsp;
                                <input
                                  className="border border-gray-300 rounded-md p-2"
                                  type="text"
                                  placeholder="Type here"
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                LE:&nbsp;{" "}
                                <input
                                  className="border border-gray-300 rounded-md p-2"
                                  type="text"
                                  placeholder="Type here"
                                />
                              </td>
                            </tr>{" "}
                          </tbody>
                        </table>
                      </td>
                      <td className="flex mt-16 justify-evenly">
                        {editIcon} &nbsp;&nbsp;
                        {deleteIcon}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* table second end*/}
              {/* headings for third table */}
              <div className="flex justify-between p-4 m-auto w-[1275px]">
                <p className="text-xl font-bold">Dispensing History</p>
                <div className="flex justify-between w-[30%]">
                  <p className="text-xl font-bold">Date:</p>&nbsp;&nbsp;
                  <input type="date" className="bg-white p-2 w-full" />
                </div>
              </div>
              <div className="w-[1275px] p-4 m-auto overflow-x-auto">
                <table className="rounded-md w-full">
                  <thead>
                    <tr className="bg-blue-100">
                      <th>Record ID</th>
                      <th>Test Date</th>
                      <th>Payment</th>
                      <th>Lens Details</th>
                      <th>Frame Make</th>
                      <th>Frame Model</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white">
                    <tr className="text-center">
                      <td>1234</td>
                      <td>12/1/2023</td>
                      <td>768$</td>
                      <td>Varifocal</td>
                      <td>Tomford</td>
                      <td>2344</td>
                      <td className="flex justify-evenly">
                        {editIcon}
                        {deleteIcon}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />
              {/* last buttons */}
              <div className="p-10 bg-white w-[1250px] m-auto">
                <div className="grid grid-cols-3 gap-5">
                  <button
                    onClick={() =>
                      changeTab("New Sight Test", "Patient Information")
                    }
                    type="button"
                    className="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2 w-full"
                  >
                    {eyeIcon} &nbsp;&nbsp; New Sight Test
                  </button>

                  <button
                    type="button"
                    className="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2 w-full"
                  >
                    {eyeIcon} &nbsp;&nbsp; New CL/L Test
                  </button>

                  <button
                    type="button"
                    className="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2 w-full"
                  >
                    {eyeIcon} &nbsp;&nbsp; New Dispense
                  </button>

                  {/* row 2 */}
                  <button
                    type="button"
                    className="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2 w-full"
                  >
                    {attachementIcon} &nbsp;&nbsp; New Attachement
                  </button>
                  <button
                    type="button"
                    className="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2 w-full"
                  >
                    {eyeIcon} &nbsp;&nbsp; C/L Aftercare
                  </button>
                  <button
                    type="button"
                    className="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2 w-full"
                  >
                    {eyeIcon} &nbsp;&nbsp; Pre-screening
                  </button>
                  {/* row 3 */}
                  <div></div>
                  <button
                    type="button"
                    className="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2 w-full"
                  >
                    {appointmentIcon} &nbsp;&nbsp; Make Appointment
                  </button>
                  <div></div>
                </div>
              </div>
            </>
          )}
          {/* When Tab === "New Sight Test" is active, we are importing our components as tabs data */}
          {Tab === "New Sight Test" && (
            <div className="bg-white w-[1275px] m-auto">
              {/* Parent Tab */}
              <NewSightTest activeTab={Tab2} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Patient;
